import MoneyDTO from "@/models/MoneyDTO";

export default interface TraderPayoutSettingsDTO {
  minAmount: string|null;
  maxAmount: string|null;
  onlyMir: boolean;
  autoAccept: boolean;
  multiplesOfValue1000: boolean;
  currencies: string[];
  paymentMethods: string[];
  paymentOptions: string[];
  maxActiveDealsCount: number|null;
  traderId: number|null;
  limitIntervalMinutes: number|null;
  limitSum: MoneyDTO|null
  limitAmount: null|string
  isPayinBalanceLimitEnabled: boolean;
  isPayinBalanceLimitActive: boolean;
  balanceByCurrency: Record<string, string> | null;
  balanceResetAt: string | null;
}

export const defaultDto = {
  minAmount: null,
  maxAmount: null,
  onlyMir: false,
  autoAccept: false,
  multiplesOfValue1000: false,
  currencies: [],
  paymentMethods: [],
  paymentOptions: [],
  maxActiveDealsCount: null,
  limitSum: null,
  limitAmount: null,
  limitIntervalMinutes: null,
  traderId: null,
  isPayinBalanceLimitEnabled: false,
  isPayinBalanceLimitActive: false,
  balanceByCurrency: null,
  balanceResetAt: null,
} as TraderPayoutSettingsDTO
